/* global API_ROOT */
/* eslint-disable import/prefer-default-export */
import { artistsRandomFetch } from '../artists'
import { testimonialRandomFetch } from '../testimonials'

export const schoolDispatchers = dispatch => ({
  loadRandomArtists() {
    dispatch(artistsRandomFetch({ page_size: 3 })())
  },
  loadRandomTestimonial() {
    dispatch(testimonialRandomFetch())
  }
})
